import { Dialog } from "primereact/dialog";
import { useDispatch, useSelector } from "react-redux";
import { setIsInvoicesDetailsPopupOpen } from "src/redux/slices/invoiceSlice";
import { useTranslation } from "react-i18next";
import InvoiceDetails from "./InvoiceDetails";
import {
  generateInvoiceURLHandler,
  isInvoiceNotPaid,
} from "src/utils/common";
import { setPaymentInitiator } from "src/redux/slices/lookupSlice";
import { useEffect, useRef } from "react";
import { PaymentInitiator } from "src/resources/enum";
import InvoiceFooter from "./InvoiceFooter";

const InvoicesDetailsPopup = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation(["common", "registration", "invoice"]);

  const contentRef = useRef(null);

  const isInvoicesDetailsPopupOpen = useSelector(
    (state: any) => state.invoices.isInvoicesDetailsPopupOpen
  );

  const { invoiceID, conslidatedInvoiceID, paymentStatus } = useSelector(
    (state: any) => state.invoices?.invoiceDetailsPopupData?.invoiceDetails
  );

  const closePopup = (): void => {
    dispatch(setIsInvoicesDetailsPopupOpen(false));
  };
  const payInvoiceHandler = (): void => {
    generateInvoiceURLHandler(dispatch, invoiceID);
  };
  useEffect(() => {
    dispatch(setPaymentInitiator(PaymentInitiator.Invoice));
  }, []);

  const showPayButton =
    !conslidatedInvoiceID && isInvoiceNotPaid(paymentStatus);
  return (
    <Dialog
      visible={isInvoicesDetailsPopupOpen}
      onHide={closePopup}
      header={t("invoiceDetailsHeader")}
      headerClassName="popup-header"
      className="maintenance-requests-details-popup invoice-popup"
    >
      <div className="pt-0 building-details-form">
        <InvoiceDetails contentRef={contentRef} />
        <InvoiceFooter
          showPayButton={showPayButton}
          contentRef={contentRef}
          payInvoiceHandler={payInvoiceHandler}
        />
      </div>
    </Dialog>
  );
};

export default InvoicesDetailsPopup;
